module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"card.in-progress.title":"งานซ่อมที่ค้างอยู่","card.payment.title":"งานซ่อมค้างจ่าย","card.recent.title":"งานซ่อมล่าสุด","card.refer-work.title":"งานซ่อมที่ถูกส่งต่อมาให้ {name} (Refer Service)"}}')
  delete Component.options._Ctor
}
